export function createLoadingSelector(...namesToCheck) {
  return function (state) {
    return state.loading.loadingInProgress
      .some(inProgress => namesToCheck.includes(inProgress));
  }
}
